import { useContext, useEffect, useState } from 'react'
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '../../../common/Modal'
import {
  SET_PLANT_DATA,
  SET_SELECTED_TEST_ZONE_DATA,
  SHOW_TEST_ZONE_FORM,
  TestZoneContext,
  UPDATE_CHANGE_TEST_ZONE_DATA,
} from '../context/context'
import SelectInput from '../../../common/SelectInput'
import { getRequest, postRequest, putRequest } from '../../../../services/base'
import TextArea from '../../../common/TextArea'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import useDebouncedValue from '../../../../utils/common_function'
import { NavContext } from '../../../../context/global_context'

const TestZoneForm = ({ getTestZoneList = () => {} }) => {
  const [navState, navDispatch] = useContext(NavContext)

  const [state, dispatch] = useContext(TestZoneContext)
  const [searchPlants, setSearchPlants] = useState('')
  const debouncedToSearchPlants = useDebouncedValue(searchPlants, 1000)

  const getPlantList = async (search = '') => {
    let res = await getRequest(`/api/plants/?search=${search}`)
    dispatch({ type: SET_PLANT_DATA, data: res.results })
  }

  const saveTestZone = async (e) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Saving Test Zone.`,
        showLoader: true,
      },
      notification: {},
    })
    const form = e.target
    const formData = new FormData(form)
    if (state?.selectedObject?.id) {
      let res = await putRequest(
        `/api/test_zone/${state?.selectedObject?.id}/`,
        formData
      )

      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Test Zone Updated Successfully',
          },
        })
        dispatch({
          type: UPDATE_CHANGE_TEST_ZONE_DATA,
          data: state?.selectedObject,
        })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    } else {
      let res = await postRequest(`/api/test_zone/`, formData)
      getTestZoneList('')
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Test Zone Saved Successfully',
          },
        })
        dispatch({ type: SHOW_TEST_ZONE_FORM, showFormPopup: false, data: {} })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    }
  }

  useEffect(() => {
    getPlantList(searchPlants)
  }, [debouncedToSearchPlants])

  return (
    <Modal
      onClose={() => {
        dispatch({ type: SHOW_TEST_ZONE_FORM, showFormPopup: false, data: {} })
      }}
      show={state.showFormPopup}
    >
      <ModalHeader className={'text-white'}>
        {state?.selectedObject?.id
          ? 'Update Existing Test Zone'
          : 'Create New Test Zone'}
      </ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            saveTestZone(e)
          }}
        >
          <input
            type="hidden"
            value={state?.selectedObject?.id ? false : true}
            name="is_create"
          />
          {state?.selectedObject?.id && (
            <input type="hidden" name="id" value={state?.selectedObject?.id} />
          )}

          <div className="flex">
            <div className="w-full">
              <SelectInput
                value={state?.selectedObject?.plant}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_TEST_ZONE_DATA,
                    data: {
                      ...state?.selectedObject,
                      plant: value,
                    },
                  })
                }}
                label="Select Plant"
                name="plant"
                isRequired={false}
                options={state?.plants}
                optionLabel={'name'}
                optionValue={'id'}
                onInputChange={(value) => {
                  setSearchPlants(value)
                }}
              />
            </div>
          </div>
          <div className="flex">
            <div className="w-full">
              <InputText
                name="specifier"
                type="text"
                label="Specifier"
                value={state?.selectedObject?.specifier}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_TEST_ZONE_DATA,
                    data: {
                      ...state?.selectedObject,
                      specifier: value,
                    },
                  })
                }}
              />
            </div>
          </div>
          <div className="flex">
            <div className="w-full">
              <TextArea
                name="description"
                type="text"
                label="Test Zone Description"
                value={state?.selectedObject?.description}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_TEST_ZONE_DATA,
                    data: {
                      ...state?.selectedObject,
                      description: value,
                    },
                  })
                }}
              />
            </div>
          </div>
          <div className="flex justify-end">
            <div className="w-1/4">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 px-2 w-full justify-end`}
                onClick={(e) => {}}
                value={'text'}
                text={
                  state?.selectedObject?.id
                    ? 'Save Test Zone'
                    : 'Create New Test Zone'
                }
              />
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default TestZoneForm
